
/// <amd-module name="Search/Hub/Constants" />
export namespace SecurityConstants {
    export const Namespace = "ca535e7e-67ce-457f-93fe-6e53aa4e4160";
    export const ReadPermission = 1;
    export const PermissionTelemetry = "SearchSecurityPermissionTelemetry";
    export const PermissionFeatureFlag = "WebAccess.Search.EvaluatePermissions";
}

export namespace TelemetryConstants {
    export const L2SearchBarFocused = "L2SearchBarFocused";
}